"use strict";

// Determine if a tab node is disabled
function isTabDisabled(node) {
  return node.getAttribute('aria-disabled') === 'true';
}
module.exports = isTabDisabled;
//# sourceMappingURL=determineIsDesabledTab.js.map